const PREFIX = 'int:';

export const isInternalCostCenterId = (costCenter: string): boolean =>
  costCenter.startsWith(PREFIX);

export const fromInternalCostCenterToId = (
  internalCostCenter: string
): string => internalCostCenter.replace(PREFIX, '');

export const toInternalCostCenterId = (id: string | undefined): string => {
  if (id) {
    return PREFIX + id;
  }
  return '';
};

export const toInternalCostCenterDisplayText = (name: string): string =>
  `INT - ${name}`;
